module.exports = __webpack_public_path__ + "img/venue-bg.805bfc28.jpg";